export class ObjectStoreCoverageBreakdown {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "totalBucketBytes",
            "baseName": "totalBucketBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "backableObjects",
            "baseName": "backableObjects",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "backableBytes",
            "baseName": "backableBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "backedUpObjects",
            "baseName": "backedUpObjects",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "backedUpBytes",
            "baseName": "backedUpBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "unaccountedBytes",
            "baseName": "unaccountedBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "notBackedUp",
            "baseName": "notBackedUp",
            "type": "Array<ObjectStoreCoverageReasonEntry>",
            "format": ""
        },
        {
            "name": "tierByClass",
            "baseName": "tierByClass",
            "type": "Array<ObjectStoreTierClass>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ObjectStoreCoverageBreakdown.attributeTypeMap;
    }
    constructor() {
    }
}
